// Canonical list of all card fields used across the app.
// key   = the DB column name / form field name sent to the backend
// label = human-readable English label shown in the UI
export const ALL_FIELDS = [
  { key: 'student_name',  label: 'Name' },
  { key: 'student_id',   label: 'ID Number' },
  { key: 'father_name',  label: "Father's Name" },
  { key: 'mother_name', label: "Mother's Name" },
  { key: 'class_name',   label: 'Class' },
  { key: 'blood_group',  label: 'Blood Group' },
  { key: 'address',      label: 'Address' },
  { key: 'date_of_birth',label: 'Date of Birth' },
  { key: 'mobile_number',label: 'Mobile' },
  { key: 'session',      label: 'Session' },
  { key: 'department',   label: 'Department' },
  { key: 'designation',  label: 'Designation' },
  { key: 'husband_name', label: "Husband's Name" },
  { key: 'roll',             label: 'Roll No' },
  { key: 'section',          label: 'Section' },
  { key: 'index_no',         label: 'Index No' },
  { key: 'nid_no',           label: 'NID No' },
  { key: 'joining_date',     label: 'Joining Date' },
  { key: 'guardians_mobile', label: "Guardian's Mobile" },
  { key: 'registration_no',  label: 'Registration No' },
];

// student_name and student_id are always required; others are optional
export const REQUIRED_FIELDS = new Set(['student_name', 'student_id']);

// Map from field key → form field name actually sent to the backend
// (student_name in the UI maps to "name" in the API form body)
export const FIELD_TO_API = {
  student_name:  'name',
  student_id:    'student_id',
  father_name:   'father_name',
  mother_name:   'mother_name',
  class_name:    'class_name',
  blood_group:   'blood_group',
  address:       'address',
  date_of_birth: 'date_of_birth',
  mobile_number: 'mobile_number',
  session:       'session',
  department:    'department',
  designation:   'designation',
  husband_name:  'husband_name',
  roll:             'roll',
  section:          'section',
  index_no:         'index_no',
  nid_no:           'nid_no',
  joining_date:     'joining_date',
  guardians_mobile: 'guardians_mobile',
  registration_no:  'registration_no',
};

export const getFieldLabel = (key) =>
  ALL_FIELDS.find((f) => f.key === key)?.label ?? key;

// Input length limits: mobile-type fields are capped at 13 characters,
// every other field at 23. Accepts either the UI key or the API key.
export const MOBILE_FIELDS = new Set(['mobile_number', 'guardians_mobile', 'mobile', 'phone']);
export const maxLenFor = (key) => (MOBILE_FIELDS.has(key) ? 13 : 23);
